export default function Carousel({imagenesCarousel}) {
    if (!imagenesCarousel) return <div></div>
    return (
        <div id="carouselExampleIndicators" className="carousel slide" data-bs-ride="carousel">
            <div className="carousel-indicators">
                {imagenesCarousel.map((_,index)=>(
                    <div key={`btn-${index}`}>
                        <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to={`${index}`} className="active" aria-current="true" aria-label="Slide 1"></button>                        
                    </div>
                ))}                
            </div>
            <div className="carousel-inner">
                {
                    imagenesCarousel.map((img) => (
                        <div key={img.id} className={img.id===1 ? "carousel-item active" : "carousel-item"}>
                            {img.href?
                                <a href={img.href}><img src={img.url} className="d-block carousel-img-item" alt={`imagen${img.id}`}/></a>
                                :<img src={img.url} className="d-block carousel-img-item" alt={`imagen${img.id}`}/>
                            }
                        </div>
                    ))
                }                
            </div>
            <button className="carousel-control-prev" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="prev">
                <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                <span className="visually-hidden">Previous</span>
            </button>
            <button className="carousel-control-next" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="next">
                <span className="carousel-control-next-icon" aria-hidden="true"></span>
                <span className="visually-hidden">Next</span>
            </button>
        </div>
    )
}
